import { SunspotLoader } from 'react-awesome-loaders'

const Loader = () => {
    return (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <SunspotLoader
                gradientColors={['#4039d4', '#E0E7FF']}
                size={'10px'}
                desktopSize={'30px'}
                mobileSize={'20px'}
                className="m-auto"
            />
        </div>
    )
}

export default Loader